import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=0285b8e2&lang=html&"
import script from "./Styles.vue?vue&type=script&lang=js&"
export * from "./Styles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports